/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-unresolved */
import React, {useState, useEffect, useCallback} from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Typography, FormControl, Radio, RadioGroup, FormControlLabel, Box, Card, IconButton, Container, Divider, MenuItem, Grid, CardHeader, CardContent, Avatar, Button
} from "@mui/material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import {getImage, getURI, isMarketPlace} from "helpers/utils";

import ButtonComponent from "components/Button";
import RadioButtonFieldComponent from "components/RadioButtonField";
import SelectFieldComponent from "components/SelectField";
import { H6, SpanInline } from "components/CustomTypography";

import * as Actions from "actions";
import * as ActionsBase from "actions/core/core.actions";
import * as ActionTypes from "constants/ActionTypes";
import { getCartTotal } from "services";
import { useHistory } from "react-router-dom";
import ShopHeaderMini from "components/elements/main/ShopHeaderMini";
import {Notification, Pace} from "components/Atoms";

const ShopCheckout = (props) => {

  const {
    isLoading, wholesale, bootupInfo, match
  } = props;

  const [state, setState] = useState({
    address: "",
    isDelivery: false,
    shippingoption: "pickup",
    delivery_time: "10to12",
  });

  const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);

  useEffect(() => {
    props.getShippingAddress();
  }, []);

  // Set delivery as default if shop offers delivery
  useEffect(() => {
    if (bootupInfo?.shopinfo?.shippingoption && bootupInfo.shopinfo.shippingoption !== "nodelivery") {
      setState(prevState => ({
        ...prevState,
        isDelivery: true,
        shippingoption: "delivery"
      }));
    }
  }, [bootupInfo?.shopinfo?.shippingoption]);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };
  useEffect(() => {

    if (props.serviceError) {
      const feedback = {
        title: props.serviceError,
        description: props.serviceError.statusText,
      };
      sendNotification("error", feedback);
    }

    switch (props.reqStatus) {
      case ActionTypes.USER_CHECKOUT_PRODUCT_ORDER_SUCCESS:
        if (props.serviceCode === 200) {
          if (props.bootupInfo.appState.isWebsite) {
            props.history.push({
              pathname: "/cart/payment-page",
              state: {
              // payment: { paymentID: props.order.order.order_id },
                order_id: props.order.order.order_id,
                items: props.order.order.products,
                address: state.address,
                shipping: props.order.order.shipping,
                created_at: props.order.order.created_at,
                order_type: props.order.order.order_type,
                delivery_date: props.order.order.delivery_date,
                delivery_time: props.order.order.delivery_time,
                total_price: props.order.order.total_price,
                total_shipping: props.order.order.total_shipping,
                shippingoption: props.order.order.shippingoption,
                total_tax: props.order.order.total_tax,
                total_order: props.order.order.total_order,
                symbol: props.symbol,
              },
            });
          } else {
            props.history.push({
              pathname: `/shop/${props.bootupInfo.appState.subdomain_shopId}/cart/payment-page`,
              state: {
              // payment: { paymentID: props.order.order.order_id },
                order_id: props.order.order.order_id,
                items: props.order.order.products,
                address: state.address,
                shipping: props.order.order.shipping,
                created_at: props.order.order.created_at,
                order_type: props.order.order.order_type,
                delivery_date: props.order.order.delivery_date,
                delivery_time: props.order.order.delivery_time,
                total_price: props.order.order.total_price,
                total_shipping: props.order.order.total_shipping,
                shippingoption: props.order.order.shippingoption,
                total_tax: props.order.order.total_tax,
                total_order: props.order.order.total_order,
                symbol: props.symbol,
              },
            });
          }
        }
        break;
      default:
        break;
    }
  }, [props.reqStatus]);

  const handleShippingOption = (event) => {
    if (event.target.value === "delivery") {
      setState({ ...state, isDelivery: true, shippingoption: "delivery" });
    } else {
      setState({ ...state, isDelivery: false, shippingoption: "pickup" });
    }
  };

  const handleDeliveryDate = (update) => {
    setState({ ...state, delivery_date: update });
  };

  const handleDeliveryTime = (event) => {
    setState({ ...state, delivery_time: event.target.value });
  };

  const handleAddressSelect = (event) => {
    setState({ ...state, address: event.target.value });
  };

  const handleCheckoutOrder = () => {
    if ((state.isDelivery && !state.address) || isLoading) { return; }

    props.checkoutProductOrder(state, props.bootupInfo.appState.subdomain_shopId, props.bootupInfo.appState.isWebsite);
  };

  const history = useHistory();

  const handlePage = (page) => (e) => {
    history.push(page);
  };

  const {
    order, cartItems, symbol, total, shippingAddress,
  } = props;

  // Paypal Integration
  const onSuccess = (payment) => {
    if (props.bootupInfo.appState.isWebsite) {
      props.history.push({
        pathname: "/order-success",
        state: {
          payment,
          items: order.products,
          shipping: order.shipping,
          delivery_date: order.delivery_date,
          delivery_time: order.delivery_time,
          orderTotal: total,
          symbol,
        },
      });
    } else {
      props.history.push({
        pathname: "/order-success",
        state: {
          payment,
          items: order.products,
          shipping: order.shipping,
          delivery_date: order.delivery_date,
          delivery_time: order.delivery_time,
          orderTotal: total,
          symbol,
        },
      });
    }
  };

  const client = {
    sandbox: "AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_",
    production: "AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_",
  };

  const getPrice = (symbol, item) => {
    const price = item.seller_price
        - (item.product && item.product.discount
          ? (item.seller_price * (parseInt(item.product.discount, 10) / 100)) : 0);
    return (
      <Typography variant="caption" gutterBottom>
        {symbol}
        {price}
        {item.product.discount && (
          <del>
            <span className="money">
              {symbol}
              {item.seller_price}
            </span>
          </del>
        )}
      </Typography>
    );
  };

  const renderOrderItems = () => (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardHeader 
          avatar={<ShoppingCartIcon sx={{ color: 'primary.main' }} />} 
          title="Order Items Review" 
          titleTypographyProps={{ fontWeight: 600 }} 
          sx={{ bgcolor: 'grey.200' }} 
      />
      <CardContent>
        {cartItems.map((item, index) => (
          <React.Fragment key={index}>
             <Box display="flex" alignItems="center" my={1.5}>
                <Avatar variant="rounded" src={getImage(item.product.images)} sx={{ width: 60, height: 60, mr: 2 }} />
                <Box flexGrow={1}>
                   <Typography fontWeight={600} variant="subtitle2">{item.product.name}</Typography>
                   <Typography variant="body2" color="text.secondary">
                      {item.product_size && `Size: ${item.product_size}`}
                   </Typography>
                </Box>
                <Box textAlign="right">
                   <Typography variant="body2">{item.product_quantity} x {symbol}{item.seller_price}</Typography>
                   <Typography fontWeight={600}>{symbol}{(item.product_quantity * item.seller_price).toFixed(2)}</Typography>
                </Box>
             </Box>
             {index < cartItems.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </CardContent>
    </Card>
  );

  let options1;

  {
    props.bootupInfo.shopinfo.shippingoption === "nodelivery" ?
        options1 = [
          { label: "Pickup", value: "pickup" }
        ] :
        options1 = [
          {label: "Delivery", value: "delivery"},
          {label: "Pickup", value: "pickup"},
        ]
  };

  let returnpolicy;

  {
    switch (props.bootupInfo.shopinfo.returnsoption && props.bootupInfo.shopinfo.returnsoption) {
      case "exchange":
        returnpolicy = "Exchange";
        break;
      case "fullrefund":
        returnpolicy = "Full refund";
        break;
      case "noreturns":
      default:
        returnpolicy = "No Returns";
    }
  };

  const inputShippingOptions = options1.map((item) => {
    const { label, value } = item;
    return (
      <FormControlLabel value={value} control={<Radio />} label={label} />
    );
  });

  const addressOptions = shippingAddress.length > 0 && shippingAddress.map((item) => {
    const {
      _id, name, address, city,
    } = item;

    return (
        <MenuItem value={_id}
                  sx={{
                    whiteSpace: 'normal', // Allows text to wrap
                    display: 'block'     // Ensures block-level elements inside work correctly
                  }}>
          <b>{name}</b>
          <p style={{ margin: 0 }}>{address}</p>
        </MenuItem>
    );
  });

  return (
    <div>
      {isLoading && <Pace color="#27ae60" height="2px" progressbar="2px" />}
      <form>
        <Container sx={{ py: 3 }}>
          <Grid container spacing={3}>
             <Grid item xs={12} md={8}>
                <Card variant="outlined" sx={{ mb: 3 }}>
                    <CardHeader 
                        avatar={<LocalShippingIcon sx={{ color: 'primary.main' }} />} 
                        title="Delivery / Pickup Details" 
                        titleTypographyProps={{ fontWeight: 600 }} 
                        sx={{ bgcolor: 'grey.200' }} 
                    />
                    <CardContent>
                        <Box mb={2}>
                            <RadioButtonFieldComponent
                              row
                              required
                              options={inputShippingOptions}
                              label="shippingoption"
                              value={state.shippingoption}
                              onChange={(event) => handleShippingOption(event)}
                            />
                        </Box>
                        
                        <Divider sx={{ my: 2 }} />

                        { state.isDelivery && (
                            <Box>
                              <Typography variant="subtitle2" gutterBottom>Select Delivery Address</Typography>
                              <SelectFieldComponent
                                required
                                options={addressOptions}
                                label="Delivery Address"
                                value={state.address}
                                onChange={(event) => handleAddressSelect(event)}
                                fullWidth
                              />
                              <Box mt={1} onClick={handlePage(getURI(process.env.REACT_APP_TYPE, "addresses", shopId))} sx={{ cursor: 'pointer', color: 'primary.main' }}>
                                <Typography variant="body2" color="primary" fontWeight={600}>
                                  + Add New Address
                                </Typography>
                              </Box>
                            </Box>
                        )}

                        {!state.isDelivery && (
                            <Box>
                                <Typography variant="subtitle2" gutterBottom>Select Pickup Time</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <style>
                                          {`.date-picker input {
                                        width: 100%;
                                        padding: 10px;
                                        border: 1px solid #ccc;
                                        border-radius: 4px;
                                        }`}
                                        </style>
                                        <DatePicker
                                            wrapperClassName="date-picker"
                                            placeholderText="Delivery Date"
                                            selected={state.delivery_date ? state.delivery_date : state.delivery_date = new Date()}
                                            minDate={new Date()}
                                            dateFormat="MMMM d, yyyy"
                                            onChange={handleDeliveryDate}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <SelectFieldComponent name="delivery_time" label="Preferred Time" value={state.delivery_time}
                                                              onChange={(event) => handleDeliveryTime(event)} fullWidth>
                                          <MenuItem value="10to12">10:00am to 12:00pm</MenuItem>
                                          <MenuItem value="12to2">12:00pm to 2:00pm</MenuItem>
                                          <MenuItem value="2to4">2:00pm to 4:00pm</MenuItem>
                                          <MenuItem value="4to6">4:00pm to 6:00pm</MenuItem>
                                          <MenuItem value="6to8">6:00pm to 8:00pm</MenuItem>
                                        </SelectFieldComponent>
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </CardContent>
                </Card>

                {renderOrderItems()}
             </Grid>

             <Grid item xs={12} md={4}>
                <Box sx={{ position: 'sticky', top: 20 }}>
                    <Card variant="outlined">
                        <CardHeader 
                            avatar={<ReceiptLongIcon sx={{ color: 'primary.main' }} />} 
                            title="Order Summary" 
                            titleTypographyProps={{ fontWeight: 600 }} 
                            sx={{ bgcolor: 'grey.200' }} 
                        />
                        <CardContent>
                             <Box display="flex" justifyContent="space-between" mb={1}>
                                  <Typography>Total Amount:</Typography>
                                  <Typography fontWeight={600}>{symbol} {total}</Typography>
                             </Box>
                             <Typography variant="caption" color="text.secondary" display="block" mb={2}>
                                Return Policy: {returnpolicy}
                             </Typography>
                             
                             <Divider sx={{ my: 2 }} />

                             <ButtonComponent
                                variant="contained"
                                type="primary"
                                name="Continue to Payment"
                                fullWidth
                                size="large"
                                onClick={() => handleCheckoutOrder()}
                                disabled={!total}
                              />
                        </CardContent>
                    </Card>
                </Box>
             </Grid>
          </Grid>
        </Container>
      </form>
    </div>
  );
};

// Mapping Props and State.
const shopCheckout = connect(
  ({ cartList, bootupInfo }) => ({
    bootupInfo,
    symbol: bootupInfo.symbol,
    reqStatus: cartList.reqStatus,
    isLoading: cartList.isLoading,
    serviceError: cartList.serviceError,
    serviceCode: cartList.serviceCode,
    cartItems: cartList.cart,
    total: getCartTotal(cartList.cart),
    order: cartList.order,
    shippingAddress: bootupInfo.shippingAddress,
  }),
  (dispatch) => bindActionCreators({ ...Actions, ...ActionsBase }, dispatch),
)(ShopCheckout);

export { shopCheckout as default };
